<script>
import { mapGetters } from 'vuex'
import suppliersTable from './suppliers.table'
import getExportedFilename from '@lib/utils/get-exported-filename'

export default {
  name: 'Suppliers',
  page: {
    title: 'Suppliers',
  },
  data() {
    return {
      table: suppliersTable(this),
    }
  },
  computed: {
    ...mapGetters('me', [
      'canReadSupplier',
      'canCreateSupplier',
    ]),
    listeners() {
      if (this.canReadSupplier) {
        return {
          'row-click': this.onRowClick,
        }
      }

      return {}
    },
  },
  methods: {
    onRowClick(row) {
      this.$router.push({
        name: 'supplier-details',
        params: {
          id: row.id,
        },
      })
    },
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
    onButtonClick() {
      // this.createSupplierModal = true
      this.$modal.show('supplier-edit')
    },
  },
}
</script>

<template>
  <main-layout title="Suppliers">
    <template
      v-if="canCreateSupplier"
      #header
    >
      <el-button
        type="primary"
        @click="onButtonClick"
      >
        Create Supplier
      </el-button>
    </template>
    <table-layout
      :table-name="table.tableName"
      :fragments="false"
      hider
      :processor="table.processor"
      :filters="table.filters"
      :columns="table.columns"
      :export-filename="getExportedFilename"
      v-on="listeners"
    />
    <!-- <supplier-edit-modal
      v-if="createSupplierModal"
      :visible.sync="createSupplierModal"
      modal-append-to-body
      append-to-body
    /> -->
  </main-layout>
</template>
